import React from 'react';

const Header = () => {
    return(
        <div>
            
        </div>
    )
}

export default Header;